var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.editable && !_vm.disabled,
              expression: "editable&&!disabled",
            },
          ],
          staticClass: "col float-right",
        },
        [
          _c(
            "q-btn-group",
            { attrs: { outline: "" } },
            [
              _c(
                "q-chip",
                {
                  staticClass: "no-border",
                  staticStyle: { "margin-right": "5px !important" },
                  attrs: {
                    square: "",
                    outline: "",
                    color: "red",
                    "text-color": "white",
                    icon: "report",
                    size: "12px",
                  },
                },
                [
                  _vm._v(" " + _vm._s(_vm.$label("LBL0002043")) + " "),
                  _c("em", [_vm._v(_vm._s(_vm.$label("LBL0002044")))]),
                  _vm._v(" " + _vm._s(_vm.$label("LBL0002045")) + "  "),
                  _c("strong", [_vm._v(_vm._s(_vm.$label("LBL0002046")))]),
                  _vm._v(_vm._s(_vm.$label("LBL0002047")) + " "),
                ]
              ),
              _c("c-btn", {
                attrs: {
                  disabled: !_vm.checkComplete,
                  label: "LBLCOMPLETE",
                  icon: "check",
                },
                on: {
                  btnClicked: () => {
                    _vm.completeDialog = true
                  },
                },
              }),
              _c("c-btn", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: false,
                    expression: "false",
                  },
                ],
                attrs: {
                  isSubmit: _vm.isComplete,
                  url: _vm.completeUrl,
                  param: _vm.moc,
                  mappingType: "PUT",
                  label: "LBLCOMPLETE",
                  icon: "check",
                },
                on: {
                  beforeAction: _vm.completeMoc,
                  btnCallback: _vm.completeMocCallback,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("c-tab", {
        attrs: {
          type: "vertical",
          tabItems: _vm.tabItems,
          height: _vm.tabHeight,
        },
        on: {
          "update:height": function ($event) {
            _vm.tabHeight = $event
          },
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (tab) {
              return [
                _c(tab.component, {
                  key: tab.key,
                  tag: "component",
                  attrs: {
                    moc: _vm.moc,
                    relatedWork: tab.relatedWork,
                    disabled: _vm.disabled,
                  },
                  on: {
                    "update:moc": function ($event) {
                      _vm.moc = $event
                    },
                    "update:relatedWork": function ($event) {
                      return _vm.$set(tab, "relatedWork", $event)
                    },
                    "update:related-work": function ($event) {
                      return _vm.$set(tab, "relatedWork", $event)
                    },
                    "update:disabled": function ($event) {
                      _vm.disabled = $event
                    },
                    saveCallback: _vm.saveCallback,
                    changePreStartup: _vm.changePreStartup,
                  },
                }),
              ]
            },
          },
        ]),
        model: {
          value: _vm.tab,
          callback: function ($$v) {
            _vm.tab = $$v
          },
          expression: "tab",
        },
      }),
      _c(
        "q-dialog",
        {
          attrs: { persistent: "" },
          model: {
            value: _vm.completeDialog,
            callback: function ($$v) {
              _vm.completeDialog = $$v
            },
            expression: "completeDialog",
          },
        },
        [
          _c(
            "q-card",
            { staticStyle: { "min-width": "350px" } },
            [
              _c("q-card-section", [
                _c("div", { staticClass: "text-h6" }, [
                  _vm._v(_vm._s(_vm.$label("LBL0001973"))),
                ]),
              ]),
              _c(
                "q-card-section",
                { staticClass: "q-pt-none" },
                [
                  _c("q-input", {
                    attrs: { type: "textarea", dense: "", autofocus: "" },
                    model: {
                      value: _vm.moc.mocCompleteOpinion,
                      callback: function ($$v) {
                        _vm.$set(_vm.moc, "mocCompleteOpinion", $$v)
                      },
                      expression: "moc.mocCompleteOpinion",
                    },
                  }),
                ],
                1
              ),
              _c(
                "q-card-actions",
                { staticClass: "text-primary", attrs: { align: "right" } },
                [
                  _c("q-btn", {
                    attrs: { flat: "", label: _vm.$label("LBLCOMPLETE") },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.checkCompleteValid.apply(null, arguments)
                      },
                    },
                  }),
                  _c("q-btn", {
                    directives: [
                      { name: "close-popup", rawName: "v-close-popup" },
                    ],
                    attrs: { flat: "", label: _vm.$label("LBLCANCEL") },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }